import { TRootState } from 'Redux/Reducers';

export const getUserOrganizer = (state: TRootState) => {
  const { user } = state;
  if (user.organisations) {
    return user.organisations;
  }
  return null;
}
